import React, { createContext, useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

// Create context
const DirectionContext = createContext();

// Create RTL cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

// Create LTR cache
const cacheLtr = createCache({
  key: "muiltr",
  stylisPlugins: [prefixer],
});

export const DirectionProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState("ltr");

  useEffect(() => {
    const dir = i18n.language === "ar" ? "rtl" : "ltr";
    setDirection(dir);
    document.dir = dir;
  }, [i18n.language]);

  return (
    <DirectionContext.Provider value={{ direction }}>
      <CacheProvider value={direction === "rtl" ? cacheRtl : cacheLtr}>
        {children}
      </CacheProvider>
    </DirectionContext.Provider>
  );
};

export const useDirection = () => {
  const context = useContext(DirectionContext);
  if (context === undefined) {
    throw new Error("useDirection must be used within a DirectionProvider");
  }
  return context;
};

export default DirectionProvider;
